import { RouteConfig } from 'vue-router';
import * as handlers from '../handlers';
import {PackageApi} from "@/api";
import bliRoutes from "./bli"
import mdtRoutes from "./mdt"
import cmvRoutes from "./cmv"
import errorRoutes from "./errors"
import paymentRoutes from "./payment"

const index: Array<RouteConfig> = [
  {
    path: '',
    component: () => import('@/layouts/EmptyLayout.vue') ,
    children: [
      { path: '', component: () => import('@/pages/WelcomePage.vue')}
    ]
  },
  {
    path: '/',
    component: () => import('@/layouts/MainLayout.vue'),
    children: [
      {
        name: 'quote',
        path: 'quote/:packageHash?',
        component: () => import('@/layouts/QuoteLayout.vue'),
        children: [
          {
            path: 'your-details',
            component: () => import('@/pages/quote/YourDetailsPage.vue'),
            meta: {
              back: handlers.home,
              noHashAllowed: true
            }
          },
          {
            path: 'other-events',
            name: 'other-events',
            component: () => import('@/pages/quote/forms/general/ClientEventsPage.vue'),
            meta: {
              back(this: Vue): string {
                if (this.$route.name?.startsWith('bli')) {
                  return this.$router.resolve({ name: 'cmv-driver-suspensions', params: { packageHash: this.$packageHash } }).href;
                } else if (this.$route.name?.startsWith('mdt')) {
                  return this.$router.resolve({ name: 'cmv-driver-suspensions', params: { packageHash: this.$packageHash } }).href;
                } else if (this.$route.name?.startsWith('cmv')) {
                  return this.$router.resolve({ name: 'cmv-driver-suspensions', params: { packageHash: this.$packageHash } }).href;
                } else if (this.$store.state.package?.isRenewal) {
                  return `/quote/${this.$packageHash}/other-details`;
                } else {
                  return `/quote/${this.$packageHash}/your-details`;
                }
              },
              noHashAllowed: false
            }
          },
          {
            path: 'other-details',
            component: () =>
              import('@/pages/quote/renewal/RenewalOtherDetailsPage.vue'),
            meta: {
              back(this: Vue): string {
                return `/quote/${this.$packageHash}/your-details`;
              }
            }
          },
          { path: 'view', redirect: 'dashboard' },
          {
            path: 'dashboard',
            component: () => import('@/pages/quote/DashboardPage.vue'),
            meta: {
              async back(this: Vue): Promise<string> {
                const response = await new PackageApi().getPackageStatus(this.$packageHash);
                return (response.status === 200 && response.data.data?.status === 'ReferForQuote') ?
                    handlers.requote.call(this) :
                    `/quote/${this.$packageHash}/your-details`;
              },
              transitions: {
                from: {
                  '/quote/form/liability': 'slide-fade-right',
                  '/quote/form/tools': 'slide-fade-right',
                  '/quote/form/commercial-vehicles': 'slide-fade-right',
                }
              }
            }
          },
          {
            path: 'form/',
            component: () => import('@/pages/quote/forms/FormPage.vue'),
            children: [
              {
                path: 'liability/',
                component: () => import('@/pages/quote/forms/liability/LiabilityForm.vue'),
                children: bliRoutes,
              },
              {
                path: 'tools/',
                component: () => import('@/pages/quote/forms/toolsAndEquipment/ToolsAndEquipmentForm.vue'),
                children: mdtRoutes,
              },
              {
                path: 'commercial-vehicles',
                component: () => import('@/pages/quote/forms/commercialVehicles/CommercialVehiclesForm.vue'),
                children: cmvRoutes,
              },
            ]
          },
          {
            path: 'apply',
            component: () => import('@/pages/application/ApplyPage.vue'),
            meta: {
              back: handlers.requote
            }
          },
          ...paymentRoutes,
          ...errorRoutes,
        ]
      }
    ]
  },
  {
    path: '*',
    component: () => import('@/pages/error/Error404Page.vue')
  }
];

export default index;
